<template>
  <lifetime-warranty-list v-bind="$props" />
</template>

<script>
import LifetimeWarrantyList from '@/components/LifetimeWarrantyList';

export default {
  name: 'LifetimeWarrantyTab',

  components: {
    LifetimeWarrantyList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
